export default "__VITE_ASSET__CaeBdMJ5__"